const baseURL = `${process.env.REACT_APP_BASE_URL}/api/websites`

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to get domain details
const DomainDeleteApi = async (
    token: string, // access token
    websiteID: number // Domain ID
): Promise<any> => {

    let url = `${baseURL}/remove`;

    const Formdata = new FormData();
    Formdata.append("id", websiteID.toString());

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: Formdata
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export { DomainDeleteApi }